import { render, staticRenderFns } from "./TaskChangeLogTable.vue?vue&type=template&id=1f8cb197"
import script from "./TaskChangeLogTable.vue?vue&type=script&lang=js"
export * from "./TaskChangeLogTable.vue?vue&type=script&lang=js"
import style0 from "./TaskChangeLogTable.vue?vue&type=style&index=0&id=1f8cb197&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports